import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './referencePointRow.styles';

class ReferencePointTableHeader extends Component {
  render() {
    return (
      <Fragment>
        <p className={css(styles.heading)}>
          {I18n.t('referencePointTableHeader.title')}
        </p>
        <div className={css(styles.bases)}>
          <div className={css(styles.fieldsHeader, styles.healthHeader)}>
            {I18n.t('referencePointTableHeader.status')}
          </div>
          <div className={css(styles.fieldsHeader, styles.zoneHeader)}>
            {I18n.t('referencePointTableHeader.zone')}
          </div>
          <div className={css(styles.fieldsHeader, styles.locationHeader)}>
            {I18n.t('referencePointTableHeader.location')}
          </div>
          <div className={css(styles.fieldsHeader, styles.rpHeader)}>
            {I18n.t('referencePointTableHeader.rp')}
          </div>
          <div className={css(styles.fieldsHeader, styles.apmacHeader)}>
            {I18n.t('referencePointTableHeader.apmac')}
          </div>
          <div className={css(styles.fieldsHeader, styles.apHeader)}>
            {I18n.t('referencePointTableHeader.ap')}
          </div>
          <div className={css(styles.fieldsHeader, styles.apHeader)}>
            {I18n.t('referencePointTableHeader.battery')}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ReferencePointTableHeader;



// WEBPACK FOOTER //
// ./src/components/data/status/referencepoint/referencePointTableHeader.js